import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload hero image to reduce LCP resource load delay
const heroPreload = document.createElement('link');
heroPreload.rel = 'preload';
heroPreload.as = 'image';
heroPreload.href = 'https://cdn.magicpatterns.com/uploads/kvea649PjUmu3tHoiMp7QR/ChatGPT_Image_24_feb_2026,_15_07_28_(1)_(1).png';
document.head.appendChild(heroPreload);
// Meta Pixel — ID: 1576521706880844
function initMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode?.insertBefore(t, s);
  w.fbq('init', '1576521706880844');
  w.fbq('track', 'PageView');
}
initMetaPixel();
render(<App data-id="element-260" />, document.getElementById('root'));